import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createBlock as _createBlock, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "as-who-will-score__head" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "as-who-will-score__body" }
const _hoisted_5 = { class: "as-item" }
const _hoisted_6 = {
  key: 0,
  class: "as-item__sub"
}
const _hoisted_7 = {
  key: 1,
  class: "as-item__sub"
}
const _hoisted_8 = { class: "as-vs" }
const _hoisted_9 = { class: "as-vs__tile" }
const _hoisted_10 = { class: "as-vs__line" }
const _hoisted_11 = {
  key: 0,
  class: "as-vs-line-item"
}
const _hoisted_12 = { class: "as-vs-line-item__ball as-no-ball" }
const _hoisted_13 = { class: "as-icon" }
const _hoisted_14 = {
  key: 1,
  class: "as-vs-line-item"
}
const _hoisted_15 = { class: "as-vs-line-item__ball as-no-ball" }
const _hoisted_16 = { class: "as-icon" }
const _hoisted_17 = {
  key: 0,
  class: "as-vs__text"
}
const _hoisted_18 = { class: "as-bold" }
const _hoisted_19 = {
  key: 1,
  class: "as-vs__text"
}
const _hoisted_20 = { class: "as-bold" }
const _hoisted_21 = { class: "as-item" }
const _hoisted_22 = {
  key: 0,
  class: "as-item__sub as-right"
}
const _hoisted_23 = {
  key: 1,
  class: "as-item__sub as-right"
}

import IconGoalScored from '~src/components/icons/foot_stats/IconGoalScored.vue';
    import IBall from '~src/components/icons/incident/IBall.vue';
    import FootballTeamItem from '../FootballTeamItem.vue';
    import IconCorner from '~src/components/icons/foot_stats/IconCorner.vue';
    import IconPadlock from '~src/components/icons/IconPadlock.vue';
    import IconOpportunity from '~src/components/icons/foot_stats/IconOpportunity.vue';
    import IconUncertain from '~src/components/icons/foot_stats/IconUncertain.vue';
    import type { IMatch } from '~src/interfaces';
    import type { IFootyStats, ITeam, IStatsParent } from '~src/interfaces/footystats';
    import { ref } from 'vue';

    
const __default__ = {};

interface Props{
        match: IMatch;
        mode?: string;
        footyStats: IFootyStats | null;
        homeTeamInfo: ITeam | null;
        awayTeamInfo: ITeam | null;
    }

    
export default /*@__PURE__*/_defineComponent({
  ...__default__,
  __name: 'WhoWillScore',
  props: {
    match: {},
    mode: { default: 'as-win' },
    footyStats: {},
    homeTeamInfo: {},
    awayTeamInfo: {}
  },
  setup(__props: any) {

    const props = __props

    const getValueWithMode = (team = 'home', mode = 'btts', mode_half = '') => {
        // const __data: ITeam | null = team === 'home' ? props.homeTeamInfo : props.awayTeamInfo;

        const __data: IStatsParent | null = 
            props.footyStats 
                ? (team === 'home' 
                    ? props.footyStats.home_team_last_x 
                    : props.footyStats.away_team_last_x) 
                : null;

                let __mode = mode
        if(mode_half){
            __mode = mode_half
        }
        if (!__data || !__data.stats || !__data.stats.hasOwnProperty(__mode)) {
            return 0; 
        }

        return __data.stats[__mode] as number;
    }

    

    const calculatorAVG = (home: number, away: number) => {
        const _avg = (home + away) / 2

        return Math.round(_avg)
    }

    const calculatorPercent = (home: number, away: number, mode = 'home') => {
        const _total = (home + away)
        if(_total > 0){
            return Math.round((home / _total) * 100)
        }

        return 0;
    }


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(`as-who-will-score ${_ctx.mode}`)
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(IconGoalScored, { fill: "#FFAE00" }),
      (_ctx.mode == 'as-win')
        ? (_openBlock(), _createElementBlock("span", _hoisted_2, " Liệu đội " + _toDisplayString(_ctx.footyStats?.home_name) + " sẽ ghi điểm? ", 1))
        : _createCommentVNode("", true),
      (_ctx.mode == 'as-loss')
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, " Liệu đội " + _toDisplayString(_ctx.footyStats?.away_name) + " sẽ ghi điểm? ", 1))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createVNode(FootballTeamItem, {
          awayPoint: _ctx.footyStats?.pre_match_home_ppg ?? 0,
          homePoint: _ctx.footyStats?.pre_match_away_ppg ?? 0,
          footyStats: _ctx.footyStats,
          match: _ctx.match,
          modifyClass: "as-vertical",
          showName: false,
          showResult: false
        }, null, 8, ["awayPoint", "homePoint", "footyStats", "match"]),
        (_ctx.mode == 'as-win')
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _cache[0] || (_cache[0] = _createElementVNode("span", null, "Ghi bàn trong", -1)),
              _createElementVNode("span", null, _toDisplayString(getValueWithMode('home', 'firstGoalScoredPercentage_overall')) + "%", 1),
              _cache[1] || (_cache[1] = _createElementVNode("span", null, "của các trận đấu (Overall)", -1))
            ]))
          : _createCommentVNode("", true),
        (_ctx.mode == 'as-loss')
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _cache[2] || (_cache[2] = _createElementVNode("span", null, "Giữ sạch lưới ở", -1)),
              _createElementVNode("span", null, _toDisplayString(getValueWithMode('home', 'seasonCSPercentage_overall')) + "%", 1),
              _cache[3] || (_cache[3] = _createElementVNode("span", null, "của các trận đấu (Overall)", -1))
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          (_ctx.mode == 'as-win')
            ? (_openBlock(), _createBlock(IconOpportunity, { key: 0 }))
            : _createCommentVNode("", true),
          (_ctx.mode == 'as-loss')
            ? (_openBlock(), _createBlock(IconUncertain, { key: 1 }))
            : _createCommentVNode("", true),
          _createTextVNode(" " + _toDisplayString(_ctx.mode == 'as-win' ? 'Cơ hội trung bình' : 'Không chắc chắn'), 1)
        ]),
        _createElementVNode("div", _hoisted_10, [
          (_ctx.mode == 'as-win')
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _cache[4] || (_cache[4] = _createElementVNode("div", { class: "as-vs-line-item__main" }, null, -1)),
                _createElementVNode("div", {
                  class: "as-vs-line-item__win",
                  style: _normalizeStyle({
                            width: `${getValueWithMode('home', 'firstGoalScoredPercentage_overall')}%`
                        })
                }, null, 4),
                _cache[5] || (_cache[5] = _createElementVNode("div", {
                  class: "as-vs-line-item__draw",
                  style: {"width":"100%"}
                }, null, -1)),
                _cache[6] || (_cache[6] = _createElementVNode("div", { class: "as-vs-line-item__loss" }, null, -1)),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _createVNode(IBall)
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.mode == 'as-loss')
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                _cache[7] || (_cache[7] = _createElementVNode("div", { class: "as-vs-line-item__main" }, null, -1)),
                _createElementVNode("div", {
                  class: "as-vs-line-item__win",
                  style: _normalizeStyle({
                            width: `${getValueWithMode('home', 'seasonCSPercentage_overall')}%`
                        })
                }, null, 4),
                _cache[8] || (_cache[8] = _createElementVNode("div", {
                  class: "as-vs-line-item__draw",
                  style: {"width":"100%"}
                }, null, -1)),
                _cache[9] || (_cache[9] = _createElementVNode("div", { class: "as-vs-line-item__loss" }, null, -1)),
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _createVNode(IBall)
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        (_ctx.mode === 'as-win')
          ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
              _createElementVNode("span", _hoisted_18, "Cơ hội trung bình " + _toDisplayString(_ctx.footyStats?.home_name), 1),
              _cache[10] || (_cache[10] = _createTextVNode(" sẽ có bàn thắng dựa trên dữ liệu "))
            ]))
          : _createCommentVNode("", true),
        (_ctx.mode === 'as-loss')
          ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
              _createElementVNode("span", _hoisted_20, "Không chắc chắn " + _toDisplayString(_ctx.footyStats?.away_name), 1),
              _cache[11] || (_cache[11] = _createTextVNode(" sẽ có bàn thắng dựa trên dữ liệu "))
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_21, [
        _createVNode(FootballTeamItem, {
          awayPoint: _ctx.footyStats?.pre_match_home_ppg ?? 0,
          homePoint: _ctx.footyStats?.pre_match_away_ppg ?? 0,
          footyStats: _ctx.footyStats,
          match: _ctx.match,
          modeTeam: "as-away",
          modifyClass: "as-vertical",
          showName: false,
          showResult: false,
          status: "as-W"
        }, null, 8, ["awayPoint", "homePoint", "footyStats", "match"]),
        (_ctx.mode == 'as-win')
          ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
              _cache[12] || (_cache[12] = _createElementVNode("span", null, "Giữ sạch lưới ở", -1)),
              _createElementVNode("span", null, _toDisplayString(getValueWithMode('away', 'seasonCSPercentage_overall')) + "%", 1),
              _cache[13] || (_cache[13] = _createElementVNode("span", null, "của các trận đấu (Overall)", -1))
            ]))
          : _createCommentVNode("", true),
        (_ctx.mode == 'as-loss')
          ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
              _cache[14] || (_cache[14] = _createElementVNode("span", null, "Ghi bàn trong", -1)),
              _createElementVNode("span", null, _toDisplayString(getValueWithMode('away', 'firstGoalScoredPercentage_overall')) + "%", 1),
              _cache[15] || (_cache[15] = _createElementVNode("span", null, "của các trận đấu (Overall)", -1))
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ], 2))
}
}

})